import React from 'react';
import Card from '../components/ui/Card';
export default function Privacy() {
  return <div className="w-full" data-id="element-481">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-light-grey py-16" data-id="element-482">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-483">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-heading mb-4" data-id="element-484">
            Privacy & Cookie Policy
          </h1>
          <p className="text-lg text-dark" data-id="element-485">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </p>
        </div>
      </section>
      {/* Content */}
      <section className="py-16 bg-white" data-id="element-486">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8" data-id="element-487">
          <Card data-id="element-488">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-489">Introduction</h2>
            <p className="text-dark mb-4" data-id="element-490">
              Artisanfix is committed to protecting your privacy and personal
              data. This policy explains what information we collect, how we use
              it, and your rights under UK GDPR regulations.
            </p>
            <p className="text-dark" data-id="element-491">
              By using our service, you agree to the collection and use of
              information in accordance with this policy.
            </p>
          </Card>
          <Card data-id="element-492">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-493">
              What Data We Collect
            </h2>
            <p className="text-dark mb-4" data-id="element-494">
              We collect the following types of information:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark" data-id="element-495">
              <li data-id="element-496">
                <strong data-id="element-497">Personal Information:</strong> Name, email address,
                phone number, and postal address
              </li>
              <li data-id="element-498">
                <strong data-id="element-499">Health-Related Information:</strong> Medication
                schedules, appointment dates, and reminder preferences (this
                information is provided voluntarily by you)
              </li>
              <li data-id="element-500">
                <strong data-id="element-501">Payment Information:</strong> Payment details are
                processed securely through Stripe. We do not store your full
                payment card details
              </li>
              <li data-id="element-502">
                <strong data-id="element-503">Usage Data:</strong> Information about how you use our
                service, including login times and feature usage
              </li>
              <li data-id="element-504">
                <strong data-id="element-505">Technical Data:</strong> IP address, browser type, and
                device information
              </li>
            </ul>
          </Card>
          <Card data-id="element-506">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-507">
              How We Use Your Data
            </h2>
            <p className="text-dark mb-4" data-id="element-508">
              We use your data for the following purposes:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark" data-id="element-509">
              <li data-id="element-510">To provide and maintain our reminder service</li>
              <li data-id="element-511">
                To send SMS and phone call reminders at your specified times
              </li>
              <li data-id="element-512">To allow family members to access the shared dashboard</li>
              <li data-id="element-513">To process payments and manage subscriptions</li>
              <li data-id="element-514">
                To communicate with you about your account and our service
              </li>
              <li data-id="element-515">To improve our service and develop new features</li>
              <li data-id="element-516">To comply with legal obligations</li>
            </ul>
          </Card>
          <Card data-id="element-517">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-518">Data Security</h2>
            <p className="text-dark mb-4" data-id="element-519">
              We take data security very seriously and implement multiple layers
              of protection:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-520">
              <li data-id="element-521">All data is encrypted in transit using SSL/TLS</li>
              <li data-id="element-522">
                Data at rest is encrypted using industry-standard encryption
              </li>
              <li data-id="element-523">Regular security audits and updates</li>
              <li data-id="element-524">Strict access controls and authentication</li>
              <li data-id="element-525">Secure data centres with physical security measures</li>
            </ul>
            <p className="text-dark" data-id="element-526">
              Whilst we implement robust security measures, no method of
              transmission over the internet is 100% secure. We cannot guarantee
              absolute security.
            </p>
          </Card>
          <Card data-id="element-527">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-528">Data Sharing</h2>
            <p className="text-dark mb-4" data-id="element-529">
              We do not sell your personal data to third parties. We may share
              your data with:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-530">
              <li data-id="element-531">
                <strong data-id="element-532">Service Providers:</strong> Stripe for payment
                processing, SMS and phone call providers for delivering
                reminders
              </li>
              <li data-id="element-533">
                <strong data-id="element-534">Family Members:</strong> Information you choose to share
                through the family dashboard
              </li>
              <li data-id="element-535">
                <strong data-id="element-536">Legal Requirements:</strong> When required by law or to
                protect our rights
              </li>
            </ul>
            <p className="text-dark" data-id="element-537">
              All third-party service providers are carefully selected and
              required to maintain appropriate security measures.
            </p>
          </Card>
          <Card data-id="element-538">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-539">
              Your Rights Under GDPR
            </h2>
            <p className="text-dark mb-4" data-id="element-540">
              Under UK GDPR, you have the following rights:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-541">
              <li data-id="element-542">
                <strong data-id="element-543">Right to Access:</strong> Request a copy of your
                personal data
              </li>
              <li data-id="element-544">
                <strong data-id="element-545">Right to Rectification:</strong> Request correction of
                inaccurate data
              </li>
              <li data-id="element-546">
                <strong data-id="element-547">Right to Erasure:</strong> Request deletion of your data
              </li>
              <li data-id="element-548">
                <strong data-id="element-549">Right to Restriction:</strong> Request limitation of
                processing
              </li>
              <li data-id="element-550">
                <strong data-id="element-551">Right to Data Portability:</strong> Request transfer of
                your data
              </li>
              <li data-id="element-552">
                <strong data-id="element-553">Right to Object:</strong> Object to processing of your
                data
              </li>
              <li data-id="element-554">
                <strong data-id="element-555">Right to Withdraw Consent:</strong> Withdraw consent at
                any time
              </li>
            </ul>
            <p className="text-dark" data-id="element-556">
              To exercise any of these rights, please contact us at
              bhagatjenith3@gmail.com.
            </p>
          </Card>
          <Card data-id="element-557">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-558">Cookies</h2>
            <p className="text-dark mb-4" data-id="element-559">
              We use cookies to improve your experience on our site. Cookies are
              small text files stored on your device.
            </p>
            <p className="text-dark mb-4" data-id="element-560">
              <strong data-id="element-561">Types of cookies we use:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-562">
              <li data-id="element-563">
                <strong data-id="element-564">Essential Cookies:</strong> Required for the site to
                function properly (e.g., login sessions)
              </li>
              <li data-id="element-565">
                <strong data-id="element-566">Analytics Cookies:</strong> Help us understand how
                visitors use our site
              </li>
              <li data-id="element-567">
                <strong data-id="element-568">Performance Cookies:</strong> Improve site performance
                and user experience
              </li>
            </ul>
            <p className="text-dark mb-4" data-id="element-569">
              You can control cookies through your browser settings. However,
              disabling cookies may affect your ability to use certain features
              of our service.
            </p>
            <p className="text-dark" data-id="element-570">
              By continuing to use our site, you consent to our use of cookies
              as described in this policy.
            </p>
          </Card>
          <Card data-id="element-571">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-572">
              Data Retention
            </h2>
            <p className="text-dark" data-id="element-573">
              We retain your personal data for as long as necessary to provide
              our service and comply with legal obligations. When you cancel
              your subscription, we will delete your data within 90 days, unless
              we are required to retain it for legal or regulatory reasons.
            </p>
          </Card>
          <Card data-id="element-574">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-575">
              Changes to This Policy
            </h2>
            <p className="text-dark" data-id="element-576">
              We may update this Privacy & Cookie Policy from time to time. We
              will notify you of any significant changes by email or through a
              notice on our site. Your continued use of the service after
              changes are made constitutes acceptance of the updated policy.
            </p>
          </Card>
          <Card data-id="element-577">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-578">Contact Us</h2>
            <p className="text-dark mb-4" data-id="element-579">
              If you have any questions about this Privacy & Cookie Policy or
              wish to exercise your rights, please contact us:
            </p>
            <ul className="space-y-2 text-dark" data-id="element-580">
              <li data-id="element-581">
                <strong data-id="element-582">Email:</strong> bhagatjenith3@gmail.com
              </li>
            </ul>
          </Card>
        </div>
      </section>
    </div>;
}